import React from 'react'

import { SignatureProps } from '@/components/EmailSignaturePreview/signature'
import ClassicTable from '@/components/EmailSignaturePreview/TableSignature/ClassicTable'

/**
 * On-screen preview of the "Classic" signature.
 *
 * The preview and the copied markup are the same component: ClassicTable renders email-safe
 * table markup with inline styles, and `interactive` adds the only things a preview needs on
 * top — hover affordances and the app's optimised image. That is deliberate. It makes it
 * impossible for what people see here to drift from what lands in their mail client.
 */
const ClassicSignature = (props: SignatureProps) => <ClassicTable {...props} interactive />

export default ClassicSignature
